import * as React from 'react';
import IntersectionObserver from 'react-intersection-observer';
import {Section, Text, NOOP} from 'components/UIKit';
import {LongformContent} from '../../types';
import styles from './ListingLongform.scss';

export interface ListingLongformProps {
  id?: string;
  title: string;
  content: LongformContent[];
  onVisibilityChange?: any;
}

export class ListingLongform extends React.Component<ListingLongformProps> {
  handleViewportChange = (inView) => {
    const {id, onVisibilityChange = NOOP} = this.props;

    onVisibilityChange(id, inView);
  };

  render() {
    const {id, title, content} = this.props;

    return (
      <IntersectionObserver threshold={0.3} rootMargin="-72px" onChange={this.handleViewportChange}>
        <Section
          id={id}
          heading={title}
          fullWidth
          spacing="small"
          headingProps={{type: 'h5', component: 'h2'}}
          resetPaddingTop
        >
          {content.map(({heading, content, html}) => (
            <div key={heading} className={styles.Content}>
              <Text type="h3" text={heading} component="h3" />
              {html ? (
                <Text className={styles.ContentHtml} dangerouslySetInnerHTML={{__html: html}} />
              ) : (
                <Text className={styles.ContentText} text={content} />
              )}
            </div>
          ))}
        </Section>
      </IntersectionObserver>
    );
  }
}

export default ListingLongform;
